import React from 'react'
import Button from '@Components/Buttons/Button'
import { OriginalPublisherModel } from '@Entities/work/original-publisher-model'
import AddCellButton from './AddCellButton'
import type { ShareUpdateRow } from './types'

interface ShareUpdateRequestRowProps {
    row: ShareUpdateRow
    activeEditingRowId?: string
    publisher?: OriginalPublisherModel
    onAddPublisher: () => void
    onAddAdministrator: (publisher: OriginalPublisherModel) => void
    onToggleEditing: (rowId: string) => void
    onShareChange: (rowId: string, share: string) => void
}

const ShareUpdateRequestRow = ({
    row,
    activeEditingRowId,
    publisher,
    onAddPublisher,
    onAddAdministrator,
    onToggleEditing,
    onShareChange,
}: ShareUpdateRequestRowProps) => (
    <tr>
        <td>
            {row.isNew && !row.publisherName ? (
                <AddCellButton label="Add Publisher" onClick={onAddPublisher} />
            ) : (
                row.publisherName
            )}
        </td>
        <td>
            {row.isNew && row.publisherName && !row.administratorName && publisher ? (
                <AddCellButton label="Add Administrator (Optional)" onClick={() => onAddAdministrator(publisher)} />
            ) : (
                row.administratorName
            )}
        </td>
        <td>
            <input
                aria-label={`${row.publisherName || 'New row'} share`}
                readOnly={!row.editing}
                value={row.share}
                onChange={(event) => onShareChange(row.id, event.target.value)}
            />
            {row.shareError ? <p className="share-error">{row.shareError}</p> : null}
        </td>
        <td>
            <Button
                className="edit-share-button"
                mainColor
                type={row.editing ? 'secondary' : 'primary'}
                disabled={!!activeEditingRowId && activeEditingRowId !== row.id}
                onClick={() => onToggleEditing(row.id)}
            >
                {row.editing ? 'Editing' : 'Edit Share'}
            </Button>
        </td>
    </tr>
)

export default ShareUpdateRequestRow
